/* tslint:disable */
/* eslint-disable */
/**
 * Web App core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RefundPaymentToPSPTransaction
 */
export interface RefundPaymentToPSPTransaction {
    /**
     * 
     * @type {string}
     * @memberof RefundPaymentToPSPTransaction
     */
    parentTransactionId?: string;
}

/**
 * Check if a given object implements the RefundPaymentToPSPTransaction interface.
 */
export function instanceOfRefundPaymentToPSPTransaction(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function RefundPaymentToPSPTransactionFromJSON(json: any): RefundPaymentToPSPTransaction {
    return RefundPaymentToPSPTransactionFromJSONTyped(json, false);
}

export function RefundPaymentToPSPTransactionFromJSONTyped(json: any, ignoreDiscriminator: boolean): RefundPaymentToPSPTransaction {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'parentTransactionId': !exists(json, 'parentTransactionId') ? undefined : json['parentTransactionId'],
    };
}

export function RefundPaymentToPSPTransactionToJSON(value?: RefundPaymentToPSPTransaction | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'parentTransactionId': value.parentTransactionId,
    };
}

